let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
    englishNumbers = [/0/g, /1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g];
import banksCode from './banks_card_info';
import moment from 'moment-jalaali';

import _ from 'lodash'

/**
 * This function convert persian numbers to global
 * english numbers
 *
 * @param digit
 * @returns {*}
 */
function digitToEn(digit) {
    if (typeof digit === 'string') {
        for (let i = 0; i < 10; i++) {
            digit = digit.replace(persianNumbers[i], i).replace(englishNumbers[i], i);
        }
    }
    return digit;
}

/**
 * Covert numbers format
 *
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_sep
 * @param remove
 * @param round
 * @returns {string}
 */
function numberFormat(number, remove = null, decimals, dec_point, thousands_sep, round = true) {
    // Strip all characters but numerical ones.

    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            n = '' + parseFloat((rounder(n * k) / k).toFixed(prec))

            let e = parseInt(n.toString().split('e-')[1]);
            if (!isNaN(e)) {
                n *= Math.pow(10, e - 1);
                n = ('0.' + (new Array(e)).join('0') + n.toString().substring(2)).substring(0, prec + 1);
                n = n > 0 ? n : '0.0';
            }
            return n
        },
        rounder = function (n) {
            return round ? Math.floor(n) : n
        }

    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    if (number === '')
        return '';

    s = (prec ? toFixedFix(n, prec) : '' + rounder(n)).split('.');

    if (remove)
        s[0] = s[0].replace(remove, '');

    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += parseFloat(new Array(prec - s[1].length + 1).join('0'));
    }
    return s.join(dec);
}

function findNonZeroStep(number, decimals = 8) {
    try {
        let split = numberFormat(number, null, decimals).split('.')
        if (typeof split[1] !== "undefined") {
            split[1] = split[1].split('')
            for (let i = 0; i < split[1].length; i++) {
                if (+split[1][i] > 0) {
                    // plus 2 - one step for start i with zero and another step for add another number
                    return i + 2;
                }
            }
        }
    } catch (e) {
        return decimals
    }
}

/**
 * Convert any type of mobile number display to formal number
 *
 * @param phoneNumber
 * @returns {string|*}
 */
function mobileConvertToDisplayFormat(phoneNumber) {
    if (/^\+989[0-9]{9}$/.test(phoneNumber)) {
        return '0' + phoneNumber.slice(3)
    } else if (/^989[0-9]{9}$/.test(phoneNumber)) {
        return '0' + phoneNumber.slice(2)
    } else {
        return phoneNumber;
    }
}

/**
 * Convert any type of mobile number to international number
 *
 * @param phoneNumber
 * @returns {string|*}
 */
function mobileConvertToIntForm(phoneNumber) {
    if (/^\+989[0-9]{9}$/.test(phoneNumber)) {
        return phoneNumber;
    } else if (/^989[0-9]{9}$/.test(phoneNumber)) {
        return '+' + phoneNumber
    } else if (/^09[0-9]{9}$/.test(phoneNumber)) {
        return '+98' + phoneNumber.slice(1);
    }

    return null;
}

/**
 * Clean unwanted characters from number
 *
 * @param number
 * @param toNumber
 * @returns {number}
 */
function cleanNumber(number, toNumber = true) {
    return toNumber ? _.toNumber((digitToEn(number) + '').replace(/[^0-9.]/g, '')) : (digitToEn(number) + '').replace(/[^0-9.]/g, '');
}

/**
 * Minify number
 *
 * @param number
 * @returns {string|boolean}
 */
function numberNiceFA(number) {
    // number = (0 + number.replace(",", ""));

    if (isNaN(number)) return false;

    // now filter it;
    if (number >= 1000000000000) return Math.round((number / 1000000000000)) + ' ترلیون';
    else if (number >= 1000000000) return Math.round((number / 1000000000)) + ' میلیارد';
    else if (number >= 1000000) return Math.round((number / 1000000)) + ' میلیون';
    else if (number >= 1000) return Math.round((number / 1000)) + ' هزار';

    return number
}


/**
 * Validate national code
 *
 * @param code
 * @returns {boolean}
 */
const isValidNationalCode = code => {
    code = '' + code;
    if (code.length !== 10 || /(\d)(\1){9}/.test(code)) return false;

    let sum = 0,
        chars = code.split(''),
        lastDigit,
        remainder;

    for (let i = 0; i < 9; i++) sum += +chars[i] * (10 - i);

    remainder = sum % 11;
    lastDigit = remainder < 2 ? remainder : 11 - remainder;

    return +chars[9] === lastDigit;
};

/**
 *
 * @param card
 * @returns {boolean}
 */
const isValidCreditCard = card => {
    if (typeof card === 'undefined'
        || card === null
        || card.length !== 16) {
        return false;
    }

    let cardTotal = 0;
    for (let i = 0; i < 16; i += 1) {
        const c = Number(card[i]);
        if (i % 2 === 0) {
            cardTotal += ((c * 2 > 9) ? (c * 2) - 9 : (c * 2));
        } else {
            cardTotal += c;
        }
    }

    return (cardTotal % 10 === 0);
}

const isValidEmail = value => {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
}

/**
 * Find Bank's name by card number
 * @category Bank account
 * @method getBankNameFromCardNumber
 * @param digits - Card number
 * @return string | null | undefined
 */
function getBankFromCardNumber(digits) {
    if (!digits)
        return;
    let digitsLength = digits.toString().length;
    if (digits && digitsLength >= 6 && digitsLength <= 16) {
        let code_1 = digits.toString().substring(0, 8);

        let findBank = banksCode.find(function (bank) {
            let regexTemplate = new RegExp(`${bank.card_code}.*`, 'g')
            return (regexTemplate.test(code_1));
        });

        if (findBank) {
            return findBank;
        } else {
            return null;
        }
    } else {
        return null;
    }
}

/**
 * Find Bank's name by card number
 * @category Bank account
 * @method getBankNameFromCardNumber
 * @param digits - Card number
 * @return string | null | undefined
 */
function getBankFromIBANCode(digits) {
    if (!digits)
        return;

    let findBank = banksCode.find(function (bank) {
        return bank.code === digits;
    });

    if (findBank) {
        return findBank;
    } else {
        return null;
    }
}

/**
 * Chunk and concat bank credit card
 *
 * @param number
 * @param divider
 * @returns {*}
 */
function creditCardDisplayFormat(number, divider = '-') {
    return number.match(/.{1,4}/g).join(divider)
}

function birthDateDisplayFormat(number) {
    if (number) {
        let lastItem = number.slice(-1);
        number = number.replaceAll('-', '');
        let [gpOne, gpTwo, gpThree] = [number.slice(0, 4), number.slice(4, 6), number.slice(6, 8)]

        if (lastItem === '-')
            return [gpOne, gpTwo, gpThree].filter(n => n).join('-') + '-'

        return [gpOne, gpTwo, gpThree].filter(n => n).join('-')

    }
}

function nl2br(text) {
    return text.replace(/(?:\r\n|\r|\n)/g, '<br/>');
}

function toJSON(text) {
    if (!_.isEmpty(text)) {
        try {
            text = JSON.parse(text)
        } catch (e) {
            text = JSON.parse(text.replaceAll("'", '"').replaceAll("None", null).replaceAll("False", false));
        }
    }

    return text;
}

function cleanString(string) {
    return string.replace(/[|&;$%@"<>()+,]/g, '')
}

function isPersianCharacters(string) {
    return !!/^[\u0600-\u06FF\s\u200B-\u200D\uFEFF]+$/.test(string)
}

function referrer_url_extractor(string) {
    try {
        let regex = RegExp(/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/, 'g')
        if (regex.test(string))
            return string.match(regex)[0];
    } catch (e) {
        return null;
    }
}

function check_token_countdown_time(minutes, getOnly = false, newStart = false) {
    try {
        let now = moment()
        let lastTime = localStorage.getItem('last_token_send_at') ? moment(localStorage.getItem('last_token_send_at')) : undefined
        if (lastTime) {
            let duration = moment.duration(lastTime.diff(now)).asMinutes()
            if (duration > 0)
                return {
                    duration: duration,
                    renew: true
                }
            else {
                if (!getOnly)
                    localStorage.setItem('last_token_send_at', moment().add(minutes, 'minutes'));
                return {
                    duration: newStart ? minutes : 0,
                    renew: true
                }
            }
        } else {
            if (!getOnly)
                localStorage.setItem('last_token_send_at', moment().add(minutes, 'minutes'));
            return {
                duration: minutes,
                renew: false
            }
        }
    } catch (e) {
        if (!getOnly)
            localStorage.setItem('last_token_send_at', moment().add(minutes, 'minutes'));
        return {
            duration: 0,
            renew: false
        }
    }
}

export const PersianHelper = {
    digitToEn,
    numberFormat,
    findNonZeroStep,
    mobileConvertToDisplayFormat,
    mobileConvertToIntForm,
    isValidNationalCode,
    isValidCreditCard,
    cleanNumber,
    numberNiceFA,
    creditCardDisplayFormat,
    nl2br,
    toJSON,
    getBankFromCardNumber,
    getBankFromIBANCode,
    cleanString,
    isPersianCharacters,
    referrer_url_extractor,
    birthDateDisplayFormat,
    isValidEmail,
    check_token_countdown_time
};